import * as React from 'react';

// `viewBox` is required so CSS-resized renders scale instead of clipping.
// Existing call sites that didn't size via CSS keep their 30×30 default.
export default () => (
  <svg width="30" height="30" viewBox="0 0 30 30">
    <g stroke="#0067F4" strokeWidth="4" fill="none" fillRule="evenodd" strokeLinecap="round">
      <path d="M3.686 15h22.628M15 3.686v22.628" />
    </g>
  </svg>
);
